'use client';

import type { MergeabilityStatus } from '@/lib/hooks/mergeability-status/get-mergeability-status.server';
import type { MergeabilityStatusResponse } from '@/lib/hooks/mergeability-status/query-data';
import type { QueryClient } from '@tanstack/react-query';

import { withMergeReadiness } from '@/lib/hooks/mergeability-status/get-mergeability-status.server';
import { isPendingMergeabilityStatus } from '@/lib/hooks/mergeability-status/query-data';

export function rollbackQueryData<T>(
  queryClient: Pick<QueryClient, 'removeQueries' | 'setQueryData'>,
  queryKey: readonly unknown[],
  previousData: T | undefined,
) {
  if (previousData !== undefined) {
    queryClient.setQueryData(queryKey, previousData);
    return;
  }

  queryClient.removeQueries({ queryKey, exact: true });
}

export function recomputePrV2MergeabilityStatus(
  current: MergeabilityStatusResponse | undefined,
  updater: (current: MergeabilityStatus) => MergeabilityStatus,
): MergeabilityStatusResponse | undefined {
  if (!current || isPendingMergeabilityStatus(current)) {
    return current;
  }

  // Only the server mirror knows which required checks are still running.
  return withMergeReadiness(updater(current), []);
}
